import React, { FC } from 'react'
import FavoriteIcon from 'svg/heart-icon.svg'
import FavoriteFilledIcon from 'svg/heart-icon-filled.svg'
import styles from './Actions.module.scss'
import classNames from 'classnames'
import useFavorite from './useFavorite'
import useSearchProvider from 'components/SA/SearchProvider/hooks/useSearchProvider'
import { useDispatch, useSelector } from 'react-redux'
import {
  getFavorites,
  isAuthenticated as getIsAuthenticated,
  getUserID,
} from 'selectors/user/session'
import { getFavoriteSelected } from 'selectors/user/favorite'
import { SAArtwork } from 'types/Artwork'
import { Actions as FavoriteActions } from 'actions/user/favorite'
import { Actions as FlashAction } from 'actions/shared/flashMessage'
import { FlashMessage } from 'types/Shared/FlashMessage'
import { addSubNavItemsFromArtworkAttributes } from 'apps/saatchi/homepage/helpers/subNavPersonalization'

type FavoriteProps = {
  artwork: SAArtwork
  hasPrints?: boolean
}

const Favorite: FC<FavoriteProps> = ({ artwork, hasPrints }) => {
  const { getSearchProviderAttributes } = useSearchProvider()
  const isAuthenticated = useSelector(getIsAuthenticated)
  const favorites = useSelector(getFavorites)
  const userId = useSelector(getUserID)
  const selectedFavorite = useSelector(getFavoriteSelected)

  const dispatch = useDispatch()
  const favoriteItem = (favorite: { id: number; favorite: boolean }) => {
    dispatch(FavoriteActions.UPDATE(favorite))
  }
  const addMessage = (payload: FlashMessage) => {
    dispatch(FlashAction.ADD(payload))
  }

  const { formAction, onClickFavorite, isFavorite, shouldBlockEvents } = useFavorite({
    artworkId: artwork.artworkId,
    isAuthenticated,
    favorites,
    userId,
    selectedFavorite,
    favoriteItem,
    addMessage,
  })

  const handleFavoriteClick = (ev) => {
    onClickFavorite(ev)

    if (!isFavorite) {
      addSubNavItemsFromArtworkAttributes({
        artwork: {
          ...artwork,
          category: hasPrints ? 'prints' : artwork.category,
        },
        userId: userId?.toString(),
      })
    }
  }

  return (
    <button
      className={classNames(styles.iconButtonDefaultStyle, styles.iconActionContainer)}
      data-action={formAction}
      data-type='action'
      rel='nofollow'
      title={isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}
      onClick={handleFavoriteClick}
      disabled={shouldBlockEvents}
      {...getSearchProviderAttributes([{ 'button-action': 'like' }])}
    >
      <FavoriteFilledIcon
        className={classNames(styles.iconActionFavorite, {
          [styles.iconActionContainerInvisible]: !isFavorite,
        })}
      />
      {!isFavorite && <FavoriteIcon className={styles.iconActionFavorite} />}
    </button>
  )
}

export default Favorite
